import {formatter, request} from '@/utils/request';

export namespace Shop {
  export const Path = {
    Search: '/expenseapi/shop/search',
    AjaxSearch: '/expenseapi/shop/ajaxSearch',
    Query: '/expenseapi/shop/query',
    Export: '/expenseapi/shop/export',
    Get: '/expenseapi/shop/get',
    ExportShop: '/expenseapi/shop/exportShop',
    queryBySoldTo: '/expenseapi/shop/queryBySoldTo',
  };

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.Query, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.Export, formatter(options));
  }

  export async function search(body: API.ShopFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Shop[]>>(Path.Search, formatter(options));
  }

  export async function queryBySoldTo(soldToCode: string) {
    const options = {
      method: 'Get',
      body: {
        soldToCode: soldToCode
      }
    };
    return request<API.ResponseResult<API.Shop[]>>(Path.queryBySoldTo, formatter(options));
  }

  export async function ajaxSearch(body: API.ShopFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Shop[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.Shop>>(Path.Get, formatter(options));
  }

  export async function exportShop(body: API.ShopFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Shop>>(Path.ExportShop, formatter(options));
  }
}
;
